import * as Yup from 'yup'

export const exameSchema = Yup.object().shape({
  exame: Yup.string().trim().required('É necessário o nome do exame'),
})
